module.exports = __webpack_public_path__ + "static/media/tractor-3.38b6ee47.jpg";